import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './About.module.css';
import Eyebrow from '../ui/Eyebrow';

export default function About() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <section className={styles.about} id="about" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow>About</Eyebrow>
        <div className={styles.body}>
          <p>
            I have spent 20 years writing software and building products and businesses. That work has moved through federal agencies, commercial enterprises, blockchain systems, IoT platforms, and now AI-native tools. The environments changed. The job did not: understand the problem, build something that works, ship it.
          </p>
          <p>
            I am the COO of CMGT,LLC, a change management and communications consulting firm serving federal government, private sector and Fortune 500 clients. I run operations. My wife and business partner, Angie Sanders, is CEO and founder, and brings the organizational change management expertise that anchors our client work.
          </p>
          <p>
            In 2026 I founded infundra, an infrastructure-led venture platform. Its first product, AgentDelta, is an AI-native organizational change management platform currently in beta. I served as chief architect and led development and design of the platform. I also founded eSolutions360 in 2002, a web development firm that has operated continuously since.
          </p>
          <p>
            I write about what building software and businesses for two decades actually teaches you. Not the version that sounds good in a pitch deck. The version with the tradeoffs left in.
          </p>
        </div>
      </motion.div>
    </section>
  );
}
